import React, { lazy, Suspense } from 'react';
import './App.scss';
import './framework.css';
import '@fortawesome/fontawesome-pro/css/all.css';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

//import Loadable from 'react-loadable';
//import Loading from './components/Loading';

const Web = lazy(() => import('./scenes/web/web'));
const Exito = lazy(() => import('./scenes/web/scenes/Pago/Exito'));
const Manual = lazy(() => import('./scenes/web/scenes/Manual'));
const Factura = lazy(() => import('./scenes/web/scenes/Manual/Factura'));
const Vende = lazy(() => import('./scenes/web/scenes/Manual/Vende'));
const Pdf = lazy(() => import('./scenes/web/scenes/pdf'));
const Colegio = lazy(() => import('./scenes/web/scenes/Colegio'));
const Referidos = lazy(() => import('./scenes/web/scenes/Referidos'));

const IndexCertifiedCompra = lazy(() => import('./scenes/web/scenes/CertifiedCompra'));
const IndexBlearningCompra = lazy(() => import('./scenes/web/scenes/BlearningCompra'));

function App() {
  return (
    <div className="App">
      <Suspense
        fallback={
          <div className="loading__container">
            <div className="lds-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
        }
      >
        
        <Router>
          <Switch>
            <Route path="/pago/exito" name="Exito" component={Exito} />
            <Route path="/manual/factura-instante" name="Factura" component={Factura} />
            <Route path="/manual/vende-rapido" name="Vende" component={Vende} />
            <Route path="/manual" name="Manual" component={Manual} />
            <Route path="/certified" name="Certified" component={IndexCertifiedCompra} />
            <Route path="/blearning" name="Certified" component={IndexBlearningCompra} />
            <Route path="/comunicado" name="Comunicado Sunat" component={Pdf} />
            <Route path="/colegio" name="Colegio" component={Colegio} />
            <Route path="/referidos" name="Referidos" component={Referidos} />
            <Route path="/" name="Web" component={Web} />
          </Switch>
        </Router>
      </Suspense>
    </div>
  );
}

export default App;
